const Component = {
  "图片 url 不存在": "Url hình ảnh không tồn tại",
  "暂不支持下载此类型图片": "Hiện tại không hỗ trợ tải xuống loại hình ảnh này",
}

export default Component;